import { Command } from 'commander';
import { confirm } from '@inquirer/prompts';
import { ConfigService } from '../../services/config.service.js';
import { ImageService } from '../../services/image.service.js';
import { ValidationError } from '../../errors/index.js';

export function createImageDeleteCommand(): Command {
    return new Command('delete')
        .description('Delete a generated image')
        .argument('<id>', 'Image ID')
        .option('-y, --yes', 'Skip confirmation')
        .action(async (id, options) => {
            const configService = new ConfigService();
            const config = await configService.load();

            if (!config) {
                throw new ValidationError('Not initialized. Run "jai1 auth" first.');
            }

            if (!options.yes) {
                const confirmed = await confirm({
                    message: `Are you sure you want to delete image #${id}?`,
                    default: false,
                });

                if (!confirmed) {
                    console.log('Cancelled.');
                    return;
                }
            }

            const imageService = new ImageService();
            await imageService.delete(config, parseInt(id));

            console.log(`✅ Image #${id} deleted successfully.`);
        });
}
